export const FYDEOS_BYOK_ROUTE_PREFIX = 'fydeos-byok:';

const workspaceRouteTargets = new Map<string, string>();

export function setWorkspaceAIRouteTarget(
  workspaceId: string,
  routeTargetId: string | undefined
) {
  if (routeTargetId) {
    workspaceRouteTargets.set(workspaceId, routeTargetId);
  } else {
    workspaceRouteTargets.delete(workspaceId);
  }
}

export function getWorkspaceAIRouteTarget(workspaceId: string) {
  return workspaceRouteTargets.get(workspaceId);
}

export function isWorkspaceByokRouteSelected(workspaceId: string) {
  return getWorkspaceAIRouteTarget(workspaceId)?.startsWith(
    FYDEOS_BYOK_ROUTE_PREFIX
  );
}
